import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button } from '@mui/material';
import { FONT_ENUM } from '../../types/global/fonts.types';

const MINT = '#00fdc1';
const WHITE = '#f5f5f5';
const BORDER = 'rgba(255,255,255,0.07)';

export interface PublishSuccessPanelProps {
    platformLabel: string;
    platformPostUrl?: string;
}

export function PublishSuccessPanel({ platformLabel, platformPostUrl }: PublishSuccessPanelProps) {
    return (
        <Box
            sx={{
                px: 2,
                pb: 2,
                pt: 2,
                borderTop: `1px solid ${BORDER}`,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: 1.5,
            }}>
            <CheckCircleIcon
                sx={{
                    fontSize: 56,
                    color: MINT,
                    animation: 'socialPublishCheckPop 0.55s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    '@keyframes socialPublishCheckPop': {
                        '0%': { transform: 'scale(0.2)', opacity: 0 },
                        '70%': { transform: 'scale(1.08)', opacity: 1 },
                        '100%': { transform: 'scale(1)', opacity: 1 },
                    },
                }}
            />
            <Typography sx={{ fontFamily: FONT_ENUM.MAIN_BOLD, fontSize: 14, color: MINT }}>
                Publishing started
            </Typography>
            <Typography sx={{ fontSize: 13, color: WHITE, lineHeight: 1.55, maxWidth: 360 }}>
                Allow up to 2 minutes for this post to appear on your {platformLabel}. Remember to keep this link alive
                for the next 7 days to complete this campaign.
            </Typography>
            {platformPostUrl ? (
                <Button
                    size="small"
                    endIcon={<OpenInNewIcon sx={{ fontSize: 14 }} />}
                    href={platformPostUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        mt: 0.5,
                        fontSize: 12,
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        color: MINT,
                        textTransform: 'none',
                        '&:hover': { bgcolor: 'rgba(0,253,193,0.08)' },
                    }}>
                    View on {platformLabel}
                </Button>
            ) : null}
        </Box>
    );
}
